import ChakraPopUp from "../common/PopUp/ChakraPopUp";
import FormikInput from "../common/PopUp/ChakraFormik/FormikInput";
import { useFormik } from "formik";
import { useState } from "react";
import { Flex } from "@chakra-ui/react";
import { Text } from "@chakra-ui/layout";
import { createUserSchema } from "../../validation/userValidation";
import uniqid from "uniqid";
import { fetchWithToken } from "../../functions/fetch";

export default function NewUserPopUp({ isOpen, onClose, setRefetchUser }) {
  const [isSubmitting, setIsSubmitting] = useState();

  const formik = useFormik({
    initialValues: {
      name: "",
      idNumber: "",
    },
    onSubmit: async (values, { resetForm }) => {
      setIsSubmitting(true);
      const body = values;

      const res = await fetchWithToken(
        "POST",
        `${process.env.REACT_APP_BACKEND_HOST}/api/user/noLineId`,
        body,
      );
      if (res.status === 200) {
        setRefetchUser(true);
        // TODO: use refetch user state flag
        resetForm(); // clear input data
        onClose();
      } else {
        console.error(res);
      }
      setIsSubmitting(false);
    },
    validationSchema: createUserSchema,
  });

  const getErrors = (formik) => {
    const { values, touched, errors } = formik;
    const arr = [];
    for (const prop in values) {
      if (touched[prop] && errors[prop]) {
        arr.push(errors[prop]);
      }
    }
    return arr.map((item) => (
      <Text color="red.500" key={uniqid()}>
        {item}
      </Text>
    ));
  };

  return (
    <ChakraPopUp
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      title="新增會員"
      isSubmitting={isSubmitting}
      onSubmit={formik.handleSubmit}
    >
      <Flex direction="column" gap={2}>
        <FormikInput
          labelText={"姓名"}
          field="name"
          isRequired={true}
          formik={formik}
        />
        <FormikInput
          labelText={"身份證字號"}
          field="idNumber"
          isRequired={true}
          formik={formik}
        />
        {getErrors(formik)}
      </Flex>
    </ChakraPopUp>
  );
}
